const RapperMediaIndex = () => import('./views/RapperMediaIndex.vue')
const RapperMediaCreate = () => import('./views/RapperMediaCreate.vue')
const RapperMediaEdit = () => import('./views/RapperMediaEdit.vue')

export default [
  {
    path: 'media',
    name: 'rappers.media.index',
    component: RapperMediaIndex
  },
  {
    path: 'media/create',
    name: 'rappers.media.create',
    component: RapperMediaCreate
  },
  {
    path: 'media/:mediaId(\\d+)',
    name: 'rappers.media.edit',
    component: RapperMediaEdit
  }
]
